import React, { Component, useEffect, useState } from 'react'
// import { Doughnut } from 'react-chartjs-2';
import CountUp from 'react-countup'
import axios from 'axios'
import Atropos from 'atropos/react'
import admindata from '../components/admindata'
import './Dashboard.css'
import { Link, useHistory } from 'react-router-dom'
import Conflictgame from './Conflictgame'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
// import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { Doughnut, Bar } from 'react-chartjs-2'
import { Line } from 'react-chartjs-2'
import { yellow } from '@mui/material/colors'
import Loader from 'react-js-loader'
import loader from '../icons/loder.gif'
import socket from '../../socket/socket'
import { apiRequest } from '../apiServices/allApi'

const $ = require('jquery')
$.Datatable = require('datatables.net')

const ClintPage = () => {
  const [loading, setLoading] = useState(false)

  const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API
  const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }

  const history = useHistory()
  const [startDate, setStartDate] = useState(new Date())
  const [endDate, setEndDate] = useState(new Date())
  const [Admin, setAdmin] = useState(0)
  const [allData, setAllData] = useState([])
  const [todayAllData, setTodayAllData] = useState([])
  const [olddayaData, set30DayaAllData] = useState([])
  const [today, setToday] = useState(false)
  const [User, setUser] = useState(0)

  const [challange, setChallange] = useState(0)

  const [todayData, setTodayData] = useState()

  var date = new Date();
  // Outputs the current date and time
  const getYear = date.getFullYear(); // Outputs the current year
  const getgetMonth = date.getMonth(); // Outputs the current year
  const getDate = date.getDate(); // Outputs the current year

  const dateget = `${getYear}-${getgetMonth + 1}-${getDate}`;

  const [DOB, setDob] = useState("");

  const getPreviousDay = (dateString) => {
    const date = new Date(dateString);
    date.setDate(date.getDate() - 1);
    return date.toISOString().split('T')[0];
  };

  const TodayAll = async () => {

    const access_token = localStorage.getItem('token')
    const headers = {
      Authorization: `Bearer ${access_token}`
    }

    let lastdayDateParam;
    let startDateParam;

    if (!DOB) {
      // If DOB is not set, use current date and previous date
      const currentDate = new Date();
      startDateParam = currentDate.toISOString().split('T')[0];
      const previousDate = new Date(currentDate);
      previousDate.setDate(previousDate.getDate() - 1);
      lastdayDateParam = previousDate.toISOString().split('T')[0];
    } else {
      // If DOB is set, use previous day as globledate and DOB as startDate
      lastdayDateParam = getPreviousDay(DOB);
      startDateParam = DOB;
    }

    try {
      const urlDate = `api/calculation/walletbalance?lastdayDate=${lastdayDateParam}&startDate=${startDateParam}`;
      const res = await apiRequest(urlDate, "GET", null, headers);
      setAllData(res.data);
    } catch (error) {
      //  console.log(e);
    } finally {
      // setLoading(false)
    }
  }











  function normalizeDates(startDate, endDate) {
    const start = new Date(startDate);
    start.setHours(0, 0, 0, 0);

    const end = new Date(startDate);
    end.setHours(23, 59, 59, 999);

    return [start, end];
  }

  function filterData() {
    const previous = getPreviousDay(DOB);
    const [s, e] = normalizeDates(previous, DOB);
  }

  function daterange(s, e) {
    if (s > e) {
      alert('Starting date is greater than ending date')
    } else {
      setStartDate(s)
      setEndDate(e)
    }
    console.log(s, e)
    // Change start date format
    var startDate = new Date(s)
    var startDay = startDate.getDate()
    var startMonth = startDate.getMonth() + 1 // Months are zero-based
    var startYear = startDate.getFullYear()
    var startHours = startDate.getHours()
    var startMinutes = startDate.getMinutes()
    var startSeconds = startDate.getSeconds()

    // Change end date format
    var endDate = new Date(e)
    var endDay = endDate.getDate()
    var endMonth = endDate.getMonth() + 1 // Months are zero-based
    var endYear = endDate.getFullYear()
    var endHours = endDate.getHours()
    var endMinutes = endDate.getMinutes()
    var endSeconds = endDate.getSeconds()
  }

  // ...

  useEffect(() => {
    TodayAll()

    // Some1()
  }, [])

  useEffect(() => {
    TodayAll()
    if (DOB) {
      filterData()
    }
  }, [DOB])



  useEffect(() => {
    if (socket && socket.connected) {
      socket.on('liveUsers', (data) => {
        alert(1);
        console.log(data);
      });
    }

    return () => {
      if (socket && socket.connected) {
        socket.off('liveUsers');
      }
    };
  }, []);


  return loading ? (
    <>
      <div className='App'>
        <div className='item dashboaed_loader'>
          <Loader
            type='bubble-ping'
            bgColor={'#fff'}
            title={<img src={loader} alt='Loading...' />}
            color={'#000'}
            size={100}
          />
        </div>
      </div>
    </>
  ) : (
    <div className=''>
      {/* dashboard boxes */}
      <div className='row mt-3'>
        <div className='col-xl-12 col-sm-12 d_flex_both_center'>
          <h1 className='dashboard_heading'> All Hisab Khitab</h1>

        </div>
      </div>



      <div>

        <div className='mb-3'>
          <input
            type="date"
            name="DOB"
            placeholder="Date of Birth"
            value={DOB}
            onChange={e => setDob(e.target.value)}
            required
          />
        </div>

        <div className='row'>

          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>Total Wallet Balance</h3>
                <div className='card-options'> </div>
              </div>
              <div className='card-body pt-0'>
                <div className=''>
                  <div className=''>
                    <h3 className='mb-2 font-rubik'>
                      ₹

                      <CountUp
                        start={0}
                        delay={0.1}
                        duration={0.2}
                        end={allData?.finalData?.totalWalletBalance}
                      />


                    </h3>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>Today Open Balance</h3>
                <div className='card-options'> </div>
              </div>
              <div className='card-body pt-0'>
                <div className=''>
                  <div className=''>
                    <h3 className='mb-2 font-rubik'>
                      ₹

                      <CountUp
                        start={0}
                        delay={0.1}
                        duration={0.2}
                        end={allData?.finalData?.todayOpenWalletBalance}
                      />


                    </h3>
                  </div>
                </div>
              </div>


            </div>
          </div>

          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'>Today closed Balance</h3>
                <div className='card-options'> </div>
              </div>
              <div className='card-body pt-0'>
                <div className=''>
                  <div className=''>
                    <h3 className='mb-2 font-rubik'>
                      ₹

                      <CountUp
                        start={0}
                        delay={0.1}
                        duration={0.2}
                        end={allData?.finalData?.todayClosedWalletBalance}
                      />


                    </h3>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title mb-0'>Today Total deposit</h3>
                <div className='card-options' style={{ color: "red", fontSize: "12px" }}>Today Deposit + Today Bonus </div>
              </div>
              <div className='card-body pt-0'>
                <div className=''>
                  <div className=''>
                    <h3 className='mb-2 font-rubik'>
                      ₹

                      <CountUp
                        start={0}
                        delay={0.1}
                        duration={0.2}
                        end={allData?.finalData?.todayDeposit + allData?.finalData?.todaybonus }
                      />


                    </h3>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title mb-0'>Today Total Withdraw</h3>
                <div className='card-options' style={{ color: "red", fontSize: "12px" }}>Today withdraw + Today Penalty</div>
              </div>
              <div className='card-body pt-0'>
                <div className=''>
                  <div className=''>
                    <h3 className='mb-2 font-rubik'>
                      ₹

                      <CountUp
                        start={0}
                        delay={0.1}
                        duration={0.2}
                        end={allData?.finalData?.todayWithdraw + allData?.finalData?.todayPenelty}
                      />


                    </h3>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title mb-0'>Today Difference Balance</h3>
                <div className='card-options' style={{ color: "red", fontSize: "12px" }}>Today Deposit - Today Withdraw</div>
              </div>
              <div className='card-body pt-0'>
                <div className=''>
                  <div className=''>
                    <h3 className='mb-2 font-rubik'>
                      ₹

                      <CountUp
                        start={0}
                        delay={0.1}
                        duration={0.2}
                        end={allData?.finalData?.todayDinfference}
                      />


                    </h3>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'> Today Open Balance - Today Admin Earning</h3>
                <div className='card-options'> </div>
              </div>
              <div className='card-body pt-0'>
                <div className=''>
                  <div className=''>
                    <h3 className='mb-2 font-rubik'>
                      ₹

                      <CountUp
                        start={0}
                        delay={0.1}
                        duration={0.2}
                        end={allData?.finalData?.todayOpenWalletBalance - allData?.finalData?.todayCommission}
                      />


                    </h3>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'> Closed  </h3>
                <div className='card-options'> </div>
              </div>
              <div className='card-body pt-0'>
                <div className=''>
                  <div className=''>
                    <h3 className='mb-2 font-rubik'>
                      ₹

                      <CountUp
                        start={0}
                        delay={0.1}
                        duration={0.2}
                        end={allData?.finalData?.todayOpenWalletBalance - allData?.finalData?.todayCommission + allData?.finalData?.todayDinfference}
                      />


                    </h3>
                  </div>
                </div>
              </div>


            </div>
          </div>
          <div className='col-xl-3 col-sm-6'>
            <div className='card dashboard_small_card card_hover'>
              <div className='card-header border-bottom-0'>
                <h3 className='card-title'> Difference  </h3>
                <div className='card-options'> </div>
              </div>
              <div className='card-body pt-0'>
                <div className=''>
                  <div className=''>
                    <h3 className='mb-2 font-rubik'>
                      ₹

                      <CountUp
                        start={0}
                        delay={0.1}
                        duration={0.2}
                        end={(allData?.finalData?.todayOpenWalletBalance - allData?.finalData?.todayCommission + allData?.finalData?.todayDinfference)-allData?.finalData?.todayClosedWalletBalance}
                      />


                    </h3>
                  </div>
                </div>
              </div>


            </div>
          </div>





        </div>








      </div>



    </div>
  )
}

export default ClintPage
